import { iconButtonGroupDefaultStyle, toggleButtonDefaultStyle, toggleButtonGroupDefaultStyle } from './toggleGroupDefaultStyle';
export const toggleButtonStyleBuilder = (theme, size, index, toggleGroupLength) => {
  const style = toggleButtonDefaultStyle(theme, size, index, toggleGroupLength);
  return style;
};
export const toggleButtonGroupStyleBuilder = (theme, size, toggleWidth) => {
  const style = toggleButtonGroupDefaultStyle(theme, size, toggleWidth);
  return style;
};
export const iconButtonGroupStyleBuilder = size => {
  const style = iconButtonGroupDefaultStyle(size);
  return style;
};